import { useState, useEffect } from 'react'

interface Notification {
  name: string
  city: string
  pack: 'solo' | 'combo'
}

const notifications: Notification[] = [
  { name: 'Facundo L.', city: 'Córdoba', pack: 'combo' },
  { name: 'Martín H.', city: 'Rosario', pack: 'solo' },
  { name: 'Nicolás S.', city: 'Mendoza', pack: 'combo' },
  { name: 'Javier M.', city: 'Buenos Aires', pack: 'solo' },
  { name: 'Gustavo R.', city: 'La Plata', pack: 'combo' },
  { name: 'Pablo S.', city: 'San Miguel de Tucumán', pack: 'solo' },
  { name: 'Andrés C.', city: 'Salta', pack: 'combo' },
  { name: 'Matías B.', city: 'Santa Fe', pack: 'solo' },
  { name: 'Ricardo A.', city: 'Mar del Plata', pack: 'combo' },
  { name: 'Marcelo D.', city: 'Neuquén', pack: 'solo' },
  { name: 'Fernando T.', city: 'Resistencia', pack: 'combo' },
  { name: 'Jorge L.', city: 'Posadas', pack: 'solo' },
  { name: 'Sergio F.', city: 'San Salvador de Jujuy', pack: 'combo' },
  { name: 'Diego P.', city: 'Santiago del Estero', pack: 'solo' },
  { name: 'Ramiro V.', city: 'Corrientes', pack: 'combo' },
  { name: 'Hernán G.', city: 'Bahía Blanca', pack: 'solo' },
  { name: 'Leandro M.', city: 'Paraná', pack: 'combo' },
  { name: 'Cristian R.', city: 'Formosa', pack: 'solo' },
  { name: 'Walter B.', city: 'San Luis', pack: 'combo' },
  { name: 'Carlos A.', city: 'Catamarca', pack: 'solo' },
  { name: 'Ezequiel D.', city: 'La Rioja', pack: 'combo' },
  { name: 'Damián F.', city: 'Santa Rosa', pack: 'solo' },
  { name: 'Lucas T.', city: 'Rawson', pack: 'combo' },
  { name: 'Alejandro N.', city: 'Ushuaia', pack: 'solo' },
  { name: 'Tomás R.', city: 'Viedma', pack: 'combo' },
  { name: 'Ignacio C.', city: 'Río Gallegos', pack: 'solo' },
  { name: 'Santiago M.', city: 'Comodoro Rivadavia', pack: 'combo' },
  { name: 'Agustín V.', city: 'San Juan', pack: 'solo' },
  { name: 'Maximiliano P.', city: 'Concordia', pack: 'combo' },
  { name: 'Gonzalo E.', city: 'Rafaela', pack: 'solo' },
]

export function usePurchaseNotifications() {
  const [notification, setNotification] = useState<Notification | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    let currentIndex = 0
    let firstTimeout: NodeJS.Timeout
    let interval: NodeJS.Timeout

    const showNotification = () => {
      setNotification(notifications[currentIndex])
      setIsVisible(true)

      // Hide after 4 seconds (matches the progress bar duration)
      setTimeout(() => {
        setIsVisible(false)
      }, 4000)

      currentIndex = (currentIndex + 1) % notifications.length
    }

    // Defer the entire notification system setup
    const setupTimer = setTimeout(() => {
      // First notification after 10 seconds
      firstTimeout = setTimeout(showNotification, 10000)

      // Subsequent notifications every 17 seconds
      interval = setInterval(showNotification, 17000)
    }, 5000)

    return () => {
      clearTimeout(setupTimer)
      if (firstTimeout) clearTimeout(firstTimeout)
      if (interval) clearInterval(interval)
    }
  }, [])

  return { notification, isVisible }
}
